import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  RTEWrapper,
  ContentWrapper,
  ElementAreaWrapper,
} from "BaseComponents/Wrappers";
import MapBlocksToComponents from "Helpers/BlockHelper";
import { Paragraph, Ingress, H1, Bold } from "BaseComponents/Text/";
import { StandardImage } from "Components/StandardImage";
import { ARTICLEPAGE } from "Consts/pageTypes";
import { CrisisBanner } from "Components/CrisisBanner";
import styled from "styled-components";
import { StartPagePuffs, VideoBlock, LinkBlockContainer } from "Blocks";
import { Video, VideoContainer } from "Components/Video";

let StandardPage = ({
  Heading,
  Preamble,
  Text,
  Image,
  ImageText,
  TopElementArea,
  ElementArea,
  PublicAnnouncement,
  StartpagePuffs,
  Alias,
  VideoType,
  Youtube,
  Dreambroker,
}) => {
  return (
    <>
      <CrisisBanner {...PublicAnnouncement} />
      {Alias == ARTICLEPAGE && StartpagePuffs && (
        <StartPagePuffs
          margin="0 0 16px 0"
          model={StartpagePuffs}
        ></StartPagePuffs>
      )}
      <ElementAreaWrapper>
        {TopElementArea.length > 0 && MapBlocksToComponents(TopElementArea)}
      </ElementAreaWrapper>
      <H1 marginsmall="20px 0 15px 0" margin="20px 0 25px 0">
        {Heading}
      </H1>

      {Preamble && (
        <Ingress
          marginSmall="0 0 15px 0"
          margin="0 0 30px 0"
          dangerouslySetInnerHTML={{
            __html: Preamble,
          }}
        ></Ingress>
      )}
      <ContentWrapper>
        {Youtube && (
          <VideoContainer margin="15px 0 20px 0">
            <Video VideoLink={Youtube} VideoType={VideoType}></Video>
          </VideoContainer>
        )}

        {Dreambroker && !Youtube && (
          <VideoContainer margin="15px 0 20px 0">
            <Video VideoLink={Dreambroker} VideoType={VideoType}></Video>
          </VideoContainer>
        )}
        {Image && <StandardImage src={Image} byline={ImageText} />}
        {Text && (
          <RTEWrapper
            margin="0"
            bgColor="white"
            dangerouslySetInnerHTML={{
              __html: Text,
            }}
          ></RTEWrapper>
        )}
      </ContentWrapper>

      <ElementAreaWrapper>
        {ElementArea.length > 0 && MapBlocksToComponents(ElementArea)}
      </ElementAreaWrapper>
    </>
  );
};

StandardPage.propTypes = {
  Heading: PropTypes.string,
  Text: propTypes.string,
};

export default StandardPage;
